export function isFocusOverdue(task:{status:string;personal?:{inbox?:number;focus_at:string|null}},day:string){
 return !["completed","archived"].includes(task.status)&&!task.personal?.inbox&&Boolean(task.personal?.focus_at&&task.personal.focus_at<day);
}

export const taskTypeLabels:Record<string,string>={task:"Aufgabe",container:"Container",idea:"Idee",decision:"Entscheidung",followup:"Nachhalten"};

export function taskDisplayTitle(task:{type:string;title:string}){
 return task.title;
}
